<template>
    <div class="w-full h-full flex justify-center md:pt-12 text-sm">
    <container-page>
        <template #header>
            <user-profile-header
                :user="user"
                :user-images="userImages"
                :profile-image="profileImage"
                :current-user-consent="currentUserConsent"
                :full-name="userFullName"
                :route="route.name"
                :profile-setup-steps="profileSetupSteps"
            />
        </template>
        <template #nav>
            <user-profile-nav :quick-links="quickLinks" :route-path="route.path" />
        </template>
        <template #body>
            <router-view 
                :isLoading="isLoading"
                :user="user" 
                :user-images="userImages" 
                :user-groups="userGroups"
                :user-consent-logs="userConsentLogs"
                :current-user-consent="currentUserConsent"
                :retrieved-user-images="retrievedUserImages" 
                :visible-consent-form="visibleConsentForm"
                @get-user-images="getUserImages"
                @get-user-consent-logs="loadUserConsentLogs"
                @show-consent-form="showConsentForm"
                @hide-consent-form="hideConsentForm"
                @set-loading-true="setLoadingTrue"
                @set-loading-false="setLoadingFalse"
            />
        </template>
    </container-page>
    </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import ContainerPage from '../base-components/ContainerPage.vue';
import UserProfileHeader from './UserProfileHeader.vue';
import UserProfileNav from './UserProfileNav.vue';
import { getUserImagesByUserId } from '@/services/User';
import { getUserConsentLogsByUserId} from '@/services/UserConsentLog';

const store = useStore()
const route = useRoute()

const quickLinks = ref([
    {
        path: '/profile',
        label: 'General',
        displayLabel: false,
        class: 'flex w-full'
    },
    {
        path: '/profile/edit',
        label: 'Edit Profile',
        displayLabel: false,
        class: 'flex w-full'
    },
    {
        path: '/profile/upload-photos',
        label: 'Upload Photos',
        displayLabel: false,
        class: 'flex w-full',
    },
    {
        path: '/profile/photo-consent',
        label: 'Photo Consent',
        displayLabel: false,
        class: 'flex w-full',
    },
    {
        path: '/profile/change-password/null',
        label: 'Reset Password',
        displayLabel: false,
        class: 'flex w-full'
    },
])

const user = ref(store.state.auth.user)

const profileSetupSteps = computed(() => {
    return [
        {
            status: user.value.first_name && user.value.last_name ? true : false,
            name: 'Edit Profile',
            path: '/profile/edit',

        },
        {
            status: userImages.value.length > 0 ? true : false,
            name: 'Upload Photos',
            path: '/profile/upload-photos'
        },
        {
            status: currentUserConsent.value ? true : false,
            name: 'Photo Consent',
            path: '/profile/photo-consent'
        }
    ]
})

const userFullName = computed(() => {
    const fullName = store.getters['auth/showUserFullName']
    if(fullName && fullName.trim() != '') {
      return store.getters['auth/showUserFullName']
    } else {
      return null
    }
})

const profileImage = computed(() => {
    if(userImages.value.length > 0 && userImages.value.filter((userImage) => userImage.is_profile_image).length > 0) {
        return userImages.value.filter((userImage) => userImage.is_profile_image)[0]
    } else {
        return null
    }
})

const userImages = ref([])
const userConsentLogs = ref([]);

const currentUserConsent = ref(null);

const visibleConsentForm = ref(false);

const isLoading = ref(false);

const retrievedUserImages = ref(false)

const userGroups = computed(() => {
    if(store.state.auth.userGroups) {
        return store.state.auth.userGroups
    }
    return []
})

function showConsentForm() {
    visibleConsentForm.value = true
}

function hideConsentForm() {
    visibleConsentForm.value = false
}

function setLoadingTrue() {
    isLoading.value = true
}

function setLoadingFalse() {
    isLoading.value = false
}

async function getUserImages() {
    const token = store.state.auth.token
    const userId = store.state.auth.user.id
    const response = await getUserImagesByUserId(token, userId)
    if(response.status==200) {
        userImages.value = response.data
    }
    retrievedUserImages.value = true
}

async function loadUserConsentLogs() {
    isLoading.value = true
    const token = store.state.auth.token
    const userId = store.state.auth.user.id
    const response = await getUserConsentLogsByUserId(token, userId)
    console.log(response)
    if(response.status == 200) {
        userConsentLogs.value = response.data
        if(userConsentLogs.value.length > 0) {
            currentUserConsent.value = userConsentLogs.value[0]
        } else {
            visibleConsentForm.value = true
        }
    }
    isLoading.value = false
}

loadUserConsentLogs()
getUserImages()
</script>